import type { NameConfig } from '@libs/items';
import { l10nText } from '@ps-smart-cp/l10n';
import { enumToName, rawValueToEnum } from '../utils';

enum LeaseTransactionJudge {
  useRightsLease = '1',
  smallSumAssetLease = '2',
  shortLease = '3',
}

const nameConfig: NameConfig<typeof LeaseTransactionJudge> = {
  useRightsLease: l10nText({ ja: '使用権リース' }),
  smallSumAssetLease: l10nText({ ja: '少額資産リース' }),
  shortLease: l10nText({ ja: '短期リース' }),
};

const toEnum = rawValueToEnum(LeaseTransactionJudge, LeaseTransactionJudge.useRightsLease);
const toDisplay = enumToName(LeaseTransactionJudge, nameConfig);
const toDisplayWithPrefix = enumToName(LeaseTransactionJudge, nameConfig, { prefix: true });

export const leaseTransactionJudge = {
  enum: LeaseTransactionJudge,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { LeaseTransactionJudge };
